import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useAuth } from "../../components/auth/useAuth"
import { Link, useNavigate } from 'react-router-dom'
import Version from '../../version'

export default function Login() {
    const { t } = useTranslation()
    const [islogging, setIslogging] = useState(false)
    const [isCorrect, setIsCorrect] = useState(true)
    const {loginClient, clientauth} = useAuth()
    const navigate = useNavigate()
    const [credentials, setCredentials] = useState({email: '', password: ''})

    const [showPasswordOne, setShowPasswordOne] = useState(false)

    const handlePasswordVisibilityOne = () => {
        setShowPasswordOne(!showPasswordOne)
    }

    const handleSubmit = async(e) => {
        e.preventDefault()
        setIslogging(true)
        const logged = await loginClient(credentials)
        setIsCorrect(logged !== false)
        setIslogging(false)
    }

    useEffect(() => {
        if (clientauth) {
            switch (String(clientauth.rol || '').toLowerCase()) {
                case "admin":
                    navigate("/admin/dashboard")
                    break;
                case "department":
                    navigate("/department/dashboard")
                    break;
                case "commercial":
                    navigate("/commercial/dashboard")
                    break;
                default:
                    break;
            }
        }
    }, [clientauth, navigate])

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-logo">
                    <img src="/images/logo-inicio.png" alt="logotipo" height={48} />
                </div>

                <div className="login-title">{t('signin.welcome')}</div>
                <div className="login-subtitle">{t("signin.frase")}</div>

                <Form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <Form.Label>{t('signin.email')}</Form.Label>
                        <Form.Control
                            placeholder={t('signin.emailplace')}
                            type="text"
                            autoComplete="off"
                            value={credentials.email}
                            onChange={(e) => setCredentials({...credentials, email: e.target.value})}
                            isInvalid={!isCorrect}
                        />
                    </div>

                    <div className="mb-4 input-password">
                        <Form.Label>{t('signin.password')}</Form.Label>
                        <Form.Control
                            placeholder={t('signin.passwordplace')}
                            type={showPasswordOne ? 'text' : 'password'}
                            autoComplete="off"
                            value={credentials.password}
                            onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                            isInvalid={!isCorrect}
                        />
                        <img
                            className="sd-eye"
                            src={showPasswordOne ? "../images/eyeclose.svg" : "../images/eyeopen.svg"}
                            alt="toggle password"
                            onClick={handlePasswordVisibilityOne}
                        />
                    </div>

                    {!isCorrect && (
                        <div className="mb-3 text-xs" style={{ color: 'var(--danger)' }}>
                            {t('signin.loginwrong')}
                        </div>
                    )}

                    <Button variant="primary" type="submit" className="w-100" disabled={islogging}>
                        {islogging ? (
                            <span className="spinner-border spinner-border-sm align-middle"></span>
                        ) : (
                            t('signin.login')
                        )}
                    </Button>

                    <div className="text-center mt-4 text-small">
                        <Link to="/forgotpassword" className="link-underline">{t('signin.forgotpassword')}</Link>
                    </div>
                </Form>

                <div className="text-center mt-4" style={{ fontSize: '12px', color: 'var(--neutral-400)' }}>
                    <Version />
                </div>
            </div>
        </div>
    )
}
